import { defineMessages } from 'react-intl'
import { GOAL_TYPES } from '../shared/constants'

export const messages = defineMessages({
  any: {
    id: 'goaloptions.any',
    defaultMessage: 'Any',
  },
  run: {
    id: 'goaloptions.run',
    defaultMessage: 'Run',
  },
  walk: {
    id: 'goaloptions.walk',
    defaultMessage: 'Walk',
  },
  ride: {
    id: 'goaloptions.ride',
    defaultMessage: 'Ride',
  },
  numWorkouts: {
    id: 'goaloptions.workouts',
    defaultMessage: '# of workouts',
  },
  distance: {
    id: 'goaloptions.distance',
    defaultMessage: 'Distance',
  },
  duration: {
    id: 'goaloptions.duration',
    defaultMessage: 'Duration',
  },
  thisWeek: {
    id: 'goaloptions.thisweek',
    defaultMessage: 'This Week',
  },
  nextWeek: {
    id: 'goaloptions.nextweek',
    defaultMessage: 'Next Week',
  },
})

export function constructSelectOptions (intl) {
  return {
    activityType: [
      {
        label: intl.formatMessage(messages.any),
        value: '',
      },
      {
        label: intl.formatMessage(messages.run),
        value: 'sport.running',
      },
      {
        label: intl.formatMessage(messages.walk),
        value: 'sport.walking',
      },
      {
        label: intl.formatMessage(messages.ride),
        value: 'sport.cycling',
      },
    ],

    goals: [
      {
        label: intl.formatMessage(messages.numWorkouts),
        value: GOAL_TYPES.workouts.key,
      },
      {
        label: intl.formatMessage(messages.distance),
        value: GOAL_TYPES.distance.key,
      },
      {
        label: intl.formatMessage(messages.duration),
        value: GOAL_TYPES.duration.key,
      },
    ],

    startTime: [
      {
        label: intl.formatMessage(messages.thisWeek),
        value: 'thisweek',
      },
      {
        label: intl.formatMessage(messages.nextWeek),
        value: 'nextweek',
      },
    ],
  }
}
